import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapUndefinedHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.length = 1;
        this.type = Types.Undefined;
    }
}

//# sourceMappingURL=WrapUndefinedHelper.js.map
